export default (BSEURL) => {
    return {
        // 添加采购单
        addGoods: `${BSEURL}/cart/addCart`,
        // 采购单查询
        getTrolleyList: `${BSEURL}/cart/getCart`,
        // 选中商品
        selectGood: `${BSEURL}/cart/selected`,
        //  删除采购单商品
        deleteGoods: `${BSEURL}/cart/delete`,
        // 清空采购单
        clearTrolley: `${BSEURL}/cart/deleteAll`,
        // 修改采购单商品数量
        updateGoodNum: `${BSEURL}/cart/updateNumber`
    }
}



// WEBPACK FOOTER //
// ./src/api_b2c/shopping-troelly.js